export const acceptablePaymentMethods = [
  // {
  //   label: "PayPal or Credit Card",
  //   id: "PayPal",
  //   name: "paymentMethod",
  //   value: "PayPal",
  // },
  // {
  //     label: "Apple Pay (Only on Safari)",
  //     id: "Apple Pay",
  //     name: "paymentMethod",
  //     value: "Apple Pay",
  // },
  // {
  //     label: "Google Pay (Only on Google Chrome)",
  //     id: "Google Pay",
  //     name: "paymentMethod",
  //     value: "Google Pay",
  // },
  // {
  //     label: "Alipay",
  //     id: "Alipay",
  //     name: "paymentMethod",
  //     value: "Alipay",
  // },
  // {
  //     label: "WeChat Pay",
  //     id: "WeChat Pay",
  //     name: "paymentMethod",
  //     value: "WeChat Pay",
  // },
  {
    label: "Bank Transfer ",
    id: "Bank Transfer ",
    name: "paymentMethod",
    value: "Bank Transfer",
  },
];
